<div class="action-button btn">
  @if (image) {
    <cx-media class="action-button__image" [alt]="title" [container]="image" format="thumbnail"></cx-media>
  }
  <span class="action-button__title" title="{{ title }}"> {{ title }}</span>
  @if (closeButton) {
    <div class="action-button__close" (click)="onClocseClicked(product)">
      <i class="fa fa-times" aria-hidden="true"></i>
    </div>
  }
</div>
